import { apiClient } from "../axiosInstance";
import { StandardAxiosConfig } from "../common";
import { AgrianTypes, AgrianType } from "../../models";

export class AgrianAPI {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${import.meta.env.VITE_ROGO_API_URL}/agrian`;
	}

	public async getOrganizations(type: AgrianType): Promise<AgrianTypes.Organization[]> {
		const url = `${this.baseUrl}/organizations?type=${type}`;
		const response = await apiClient.get(url, StandardAxiosConfig());
		return response.data as AgrianTypes.Organization[];
	}

	public async getOrganizationsByIds(ids: string[], type: AgrianType): Promise<AgrianTypes.Organization[]> {
		const url = `${this.baseUrl}/organizations?type=${type}`;
		const response = await apiClient.post(url, ids, StandardAxiosConfig());
		return response.data as AgrianTypes.Organization[];
	}

	public async getGrowers(orgIds: string[], type: AgrianType): Promise<AgrianTypes.Grower[]> {
		const url = `${this.baseUrl}/growers?type=${type}`;
		const response = await apiClient.post(url, orgIds, StandardAxiosConfig());
		return response.data as AgrianTypes.Grower[];
	}

	public async getFarms(growerIds: string[], type: AgrianType): Promise<AgrianTypes.Farm[]> {
		const url = `${this.baseUrl}/farms?type=${type}`;
		const response = await apiClient.post(url, growerIds, StandardAxiosConfig());
		return response.data as AgrianTypes.Farm[];
	}

	public async getFields(farmIds: string[], type: AgrianType): Promise<AgrianTypes.Field[]> {
		const url = `${this.baseUrl}/fields?type=${type}`;
		const response = await apiClient.post(url, farmIds, StandardAxiosConfig());
		return response.data as AgrianTypes.Field[];
	}

	public async getSampleEvents(fieldIds: string[], type: AgrianType): Promise<AgrianTypes.HydratedSampleEvent[]> {
		const url = `${this.baseUrl}/sample-events?type=${type}`;
		const response = await apiClient.post(url, fieldIds, StandardAxiosConfig());
		return response.data as AgrianTypes.HydratedSampleEvent[];
	}

	public async getTargetEvents(fieldIds: string[], type: AgrianType): Promise<AgrianTypes.HydratedTargetEvent[]> {
		const url = `${this.baseUrl}/target-events?type=${type}`;
		const response = await apiClient.post(url, fieldIds, StandardAxiosConfig());
		return response.data as AgrianTypes.HydratedTargetEvent[];
	}

	public async getZones(fieldIds: string[], type: AgrianType): Promise<AgrianTypes.HydratedZone[]> {
		const url = `${this.baseUrl}/zones?type=${type}`;
		const response = await apiClient.post(url, fieldIds, StandardAxiosConfig());
		return response.data as AgrianTypes.HydratedZone[];
	}

	public async getLabs(type: AgrianType): Promise<AgrianTypes.Lab[]> {
		const url = `${this.baseUrl}/labs?type=${type}`;
		const response = await apiClient.post(url, undefined, StandardAxiosConfig());
		return response.data as AgrianTypes.Lab[];
	}

	public async getLabPackages(labIds: string[], type: AgrianType): Promise<AgrianTypes.LabPackage[]> {
		const url = `${this.baseUrl}/lab-packages?type=${type}`;
		const response = await apiClient.post(url, labIds, StandardAxiosConfig());
		return response.data as AgrianTypes.LabPackage[];
	}
}
